import { IonSkeletonText } from '@ionic/react'
import styled from 'styled-components'

export const Skeleton = styled(IonSkeletonText)<{ $height?: number }>`
  width: 100%;
  ${({ $height }) => $height && `height: ${$height}px`};
  border-radius: 16px;
  margin-bottom: 8px;
  margin-top: 0;
`
